module.exports = __webpack_public_path__ + "static/Columbia-gas-logo-e4de6dc5545885ed19e48be57f4fed2a.png";